import { useState, useEffect } from "react";
import axios from "axios";

export const usePropertyData = (
  url,
  transformPropertyData,
  filterParams,
  sortOption = 'Recent',
  page = 0,
  pageSize = 50
) => {
  const [data, setData] = useState([]);
  const [MapLocations, setMapLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams(filterParams);
        params.set('sort', sortOption);
        params.set('page', page.toString());
        params.set('limit', pageSize.toString());

        const { data: response } = await axios.get(`${url}?${params}`);
        const items = transformPropertyData(response.documents);

        // if page === 0, replace; otherwise append
        setData(prev => page === 0 ? items : [...prev, ...items]);
        setMapLocations(prev => page === 0 ? items : [...prev, ...items]);
        setCount(response.count);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [
    url,
    transformPropertyData,
    JSON.stringify(filterParams),
    sortOption,
    page,
    pageSize
  ]);

  return { data, MapLocations, count, loading, error };
};
